// extracted by mini-css-extract-plugin
export default {"container":"LeadingContent-module__container--cui6v","isSelectable":"LeadingContent-module__isSelectable--EzWvg","centerAligned":"LeadingContent-module__centerAligned--f1Pzo"};